import {
  Popover as ChakraPopover,
  Flex,
  PlacementWithLogical,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverHeader,
} from '@chakra-ui/react';
import * as React from 'react';

interface PopoverProps {
  hasCloseButton?: boolean;
  body?: React.ReactNode;
  placement?: PlacementWithLogical;
  variant?: string;
  children: React.ReactNode;
  title?: React.ReactNode;
}

const Popover: React.FC<PopoverProps> = ({
  title,
  children,
  variant,
  placement,
  body,
  hasCloseButton = true,
}) => {
  return (
    <ChakraPopover variant={variant} placement={placement}>
      {children}
      <PopoverContent w={{ base: '250px', md: '400px' }}>
        {(title || hasCloseButton) && (
          <PopoverHeader p={4} pb={'0px !important'} border={0}>
            <Flex flexDir="row" alignItems="center">
              {title}
              {hasCloseButton && (
                <PopoverCloseButton ml="auto" position="static" />
              )}
            </Flex>
          </PopoverHeader>
        )}

        <PopoverBody p={4}>{body}</PopoverBody>
      </PopoverContent>
    </ChakraPopover>
  );
};

export default Popover;
